import React from 'react'

export const useMouseBubbleEvents = (
  divRef: React.RefObject<HTMLDivElement>,
) => {
  const handleMouseEvent = (event: React.MouseEvent) => {
    divRef.current.dispatchEvent(
      new MouseEvent(event.type, {
        clientX: event.clientX,
        clientY: event.clientY,
        bubbles: true,
        cancelable: true,
      }),
    )
  }

  const handleWeelEvent = (event: React.WheelEvent) => {
    divRef.current.dispatchEvent(
      new WheelEvent('wheel', {
        deltaY: event.deltaY,
        deltaX: event.deltaX,
        deltaZ: event.deltaZ,
        deltaMode: event.deltaMode,
        clientX: event.clientX,
        clientY: event.clientY,
        bubbles: true,
        cancelable: true,
      }),
    )
  }

  return {
    onMouseDown: handleMouseEvent,
    onMouseMove: handleMouseEvent,
    onMouseUp: handleMouseEvent,
    onWheel: handleWeelEvent,
  }
}
